import { Divider, Grid } from "@mui/material";
import React from "react";

const WdDivider = ({ children, textAlign, ...props }) => (
  <Grid container alignItems="center" spacing={3} {...props}>
    <Grid item xs={textAlign === "left" ? 0 : true}>
      <Divider />
    </Grid>
    <Grid item>{children}</Grid>
    <Grid item xs={textAlign === "right" ? 0 : true}>
      <Divider />
    </Grid>
  </Grid>
);

export default WdDivider;
